import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from './services/loading.service';
import { MessageService } from './services/messages.service';
import { LayoutComponent } from './components/shared/layout/layout/layout.component';

@Component({
  selector: 'app-root',
  imports: [CommonModule, MatProgressSpinnerModule, LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly loadingService = inject(LoadingService);
  readonly messageService = inject(MessageService);
}
